import type { ToastType } from '../components/message';

export const TOAST_PROMPT = 'TOAST_PROMPT';
export const TOAST_REQUIRED = 'TOAST_REQUIRED';

export interface IPromptToastAction {
  type: typeof TOAST_PROMPT;
  promptType: ToastType;
  content: string;
  options: any;
}

export interface IRequiredToastAction {
  type: typeof TOAST_REQUIRED;
  required: boolean;
}

export const promptToast = (
  promptType: ToastType,
  content: string,
  options = {}
): IPromptToastAction => ({
  type: TOAST_PROMPT,
  promptType,
  content,
  options,
});

export const requireToastContainer = (): IRequiredToastAction => ({
  type: TOAST_REQUIRED,
  required: true,
});
